<template>
  <transition name="modal-slide-fade">
    <div v-show="visible"
      class="modal-bg"
    >
      <FocusTrap
        :active="visible"
        :escapeDeactivates="false"
        :allowOutsideClick="false"
        :fallbackFocus="() => $refs.dialog"
      >
        <div class="modal-dialog"
          tabindex="-1"
          ref="dialog"
        >
          <div class="modal modal-content"
            role="alertdialog"
            aria-modal="true"
            :aria-hidden="!visible"
          >
            <div class="modal-body" aria-live="polite">
              <IconButton v-if="canClose"
                class="modal-close-btn ms-1"
                iconClass="bi bi-x-lg"
                title="Close"
                @click="$emit('close')"
              />
              <slot></slot>
            </div>
          </div>
        </div>
      </FocusTrap>
    </div>
  </transition>
</template>

<script>
import { FocusTrap } from 'focus-trap-vue';
import IconButton from '@/components/buttons/Icon';

export default {
  components: { FocusTrap, IconButton },

  props: {
    canClose: {
      type: Boolean,
      default: () => false
    },

    visible: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped="true">
.modal-bg {
  display: block;
  background-color: rgba(0,0,0,0.5);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000000;
  overflow: auto;
}

.modal-dialog:focus {
  outline: none;
}

.modal-slide-fade-enter {
  .modal-content {
    top: 0;
    opacity: 0;
  }
}

.modal-body {
  padding: 1rem 2rem 2rem 2rem;
}

.modal-content {
  display: block;
  margin: auto;
  opacity: 1;
  overflow: visible;
  transition-duration: 0.5s;
  transition-property: opacity, top;
}

.modal-close-btn {
  position: absolute;
  right: 1em;
}
</style>
